import assetService from "../../../../services/assetService/assetService";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AssetInterface } from "../../../../models/AssetModel/Asset";

interface DeleteAssetContext {
  previousAssets: AssetInterface[];
  deletedAsset: AssetInterface | undefined;
}

const useDeleteAsset = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the category to delete
    DeleteAssetContext
  >({
    mutationFn: assetService.Remove, // Remove should take a string ID

    onMutate: (assetId: string) => {
      const previousAssets =
        queryClient.getQueryData<AssetInterface[]>([
          CACHE_KEY_ASSETS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<AssetInterface[]>(
        [CACHE_KEY_ASSETS, page, pageSize],
        previousAssets.filter((asset) => asset.id !== assetId) // Use assetId to filter
      );

      return {
        previousAssets,
        deletedAsset: previousAssets.find((asset) => asset.id === assetId),
      };
    },

    onError: (error, assetId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<AssetInterface[]>(
        [CACHE_KEY_ASSETS, page, pageSize],
        context.previousAssets
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteAsset;
